import React, { useEffect, useState } from 'react'

import CSSModule from 'react-css-modules';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import Button from 'components/Button/Button';
import Modal from 'components/Modal/Modal';
import { actions as fetchUsersDataActions } from 'coupon-common/src/modules/admin/userManager/fetchUsersData';
import { actions as userDetailActions } from 'coupon-common/src/modules/admin/userManager/getUserDetails'
import { actions as updatePointsActions } from 'coupon-common/src/modules/admin/userManager/updatePoints'

import styles from './AdminUpdatePoints.module.scss'
import messages from './messages';

const AdminUpdatePoints = ({dispatch, user, updatePointsModal, setUpdatePointsModal, updatePointsFetching, updatePointsData, updatePointsError}) => {

    useEffect(() => {
        if (user) {
            setSelectedUser(formatUserData(user));
        }
    }, [user]);

     useEffect(() => {
            if (apiCall) {
                if (updatePointsData?.success) {
                    alert("Points updated successfully!")
                    handleClose();
                    dispatch(userDetailActions.getUserDetails(user?.id));
                    dispatch(fetchUsersDataActions.getAllUsers());
                    setApiCall(false);
                }
                else if (updatePointsError) {
                    alert("There seems to be an issue processing this request. Please try again!")
                    handleClose();
                    setApiCall(false);
                }
            }
        }, [updatePointsData?.success, updatePointsError])

    const formatUserData = (user) => {
        return {
            id: user?.id,
            first_name: user?.first_name || user?.contact_name,
            email: user?.email,
            points: user?.wallet?.points_at_last_date || 0,
            // business: user?.name || '',
            // is_business: user?.is_business || false,
        };
    };

    const [selectedUser, setSelectedUser] = useState(null)
    const [selectedOption, setSelectedOption] = useState(null);
    const [amount, setAmount] = useState(0);
    const [totalPoints, setTotalPoints] = useState(0);
    const [notes, setNotes] = useState("Updated by Admin");
    const [apiCall, setApiCall] = useState(false);

    const calculatePoints = (amount) => {
        const userPoints = Number(selectedUser?.points);
        amount = Number(amount);

        let value;
        if (selectedOption == 'Add') {
            value = Number(userPoints + amount);
        }
        else if (selectedOption == 'Deduct') {
            if (totalPoints < amount) {
                value = "Negative amount is not allowed";
            }
            else {
                value = Number(userPoints - amount);
                amount = -amount;
            }
        }
        else if (selectedOption == 'Custom value') {
            value = Number(amount)
            if (userPoints > amount) {
                amount = -(userPoints - amount);
            }
            else if (userPoints < amount) {
                amount = -(userPoints - amount);
            }
        }
        setAmount(amount);
        setTotalPoints(value);
    }

    const handleSave = () => {
        // console.log("selected", selectedUser);
        // console.log("amount", amount);
        // console.log("notes", notes);

        dispatch(updatePointsActions.updatePoints(selectedUser?.id, amount, notes))
        // fetchUserDetails();
        setApiCall(true);
    }

    const handleClose = () => {
        setUpdatePointsModal(false);
        setSelectedUser(null);
        setSelectedOption(null);
    }


  return (
    <div>
       <Modal
                title={`Manage Points for user`}
                isOpen={updatePointsModal}
                onRequestClose={handleClose}
            >
                <div className={styles.managePointsModal}>
                    <p>
                        <span className='font-weight-bold'>{selectedUser?.first_name}

                        </span> currently has <span className='font-weight-bold'>{selectedUser?.points.toLocaleString()}
                        </span> points.</p>

                    {/* <p>Select an operation: </p> */}
                    <div className={styles.styledSelect}>
                        <select onChange={(e) => setSelectedOption(e.target.value)}>
                            <option value="" disabled selected>Select if you want to add, deduct or assign a custom value</option>
                            <option value="Add">Add Points</option>
                            <option value="Deduct">Deduct Points</option>
                            <option value="Custom value">Assign Custom Points Value</option>
                        </select>
                    </div>

                    {selectedOption && (
                        <>
                            <div className='mt-2'>
                                <span className='mr-2'>{selectedOption}</span>
                                <input
                                    type="number"
                                    min={0}
                                    onKeyDown={(e) => {
                                        // Prevent negative sign input for add or deduct but allow for custom
                                        if (!(selectedOption == "Custom value") && (e.key === '-' || e.key === 'e')) {
                                            e.preventDefault();
                                        }
                                    }}
                                    onChange={(e) => calculatePoints(e.target.value)}
                                />
                                <span className='ml-2'>points</span>
                            </div>
                            <p className='font-weight-bold'>New Points Value: {totalPoints?.toLocaleString()}</p>
                            <input type="text" maxLength={35} placeholder='Add a note (Optional), Defaults to "Updated by Admin"' onChange={(e) => setNotes(e.target.value)} />
                        </>
                    )}

                    <div className='d-flex justify-content-end'>
                        <Button outline onClick={handleClose}>
                            <FormattedMessage {...messages.cancelColumnText} />
                        </Button>
                        <Button
                            fetching={updatePointsFetching}
                            disabled={amount == 0 || typeof (totalPoints) == 'string'}
                            onClick={handleSave}
                        >
                            <FormattedMessage {...messages.saveColumnText} />
                        </Button>
                    </div>

                </div>

            </Modal>
    </div>
  )
}


const mapStateToProps = (state) => {
    return {
        authorized: state.auth.authorized,
        updatePointsData: state.admin.userManager.updatePoints.data,
        updatePointsError: state.admin.userManager.updatePoints.error,
        updatePointsFetching: state.admin.userManager.updatePointsfetching,
    };
};

export default connect(mapStateToProps)(injectIntl(CSSModule(AdminUpdatePoints, styles)));

